module.exports = __webpack_public_path__ + "img/operant_conditoning.2edf01ac.jpg";